module.exports = __webpack_public_path__ + "images/5fa62d28ec9631f88f59cf427c1f4a24.png";